module.exports = __webpack_public_path__ + "static/dashboard-mobile-0fbcee95668930769c34ecca849fe504.png";